import { apiInstance } from '@/apiInstance'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

export default function DemosPage() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadGames = async () => {
      try {
        await apiInstance.getGames()
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
      }
    }

    loadGames()
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#FEF9EC] to-white p-8 flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FEF9EC] to-white p-8">
      <div className="max-w-4xl mx-auto flex flex-col gap-12">
        <Link
          to="/demos/avatar-demos"
          className="group relative p-12 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-[#94D7D7]"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#94D7D7] to-[#987FDD] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div>
              <h2 className="text-5xl font-bold mb-4 text-gray-800">Avatar Demos</h2>
              <p className="text-xl text-gray-600">Explore our interactive avatar demonstrations</p>
            </div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#94D7D7] to-[#987FDD] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </Link>

        <Link
          to="/demos/privacy-policy"
          className="group relative p-12 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-[#94D7D7]"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#94D7D7] to-[#987FDD] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div>
              <h2 className="text-5xl font-bold mb-4 text-gray-800">Privacy Policy</h2>
              <p className="text-xl text-gray-600">
                View our interactive privacy policy demonstration
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#94D7D7] to-[#987FDD] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </Link>

        <Link
          to="/demos/story-tell"
          className="group relative p-12 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-[#94D7D7]"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#94D7D7] to-[#987FDD] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div>
              <h2 className="text-5xl font-bold mb-4 text-gray-800">Story Tell</h2>
              <p className="text-xl text-gray-600">
                View our interactive story telling game
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#94D7D7] to-[#987FDD] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </Link>


        <Link
          to="/demos/scattergories"
          className="group relative p-12 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-[#94D7D7]"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#94D7D7] to-[#987FDD] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div>
              <h2 className="text-5xl font-bold mb-4 text-gray-800">Scattergories</h2>
              <p className="text-xl text-gray-600">
                Play Scattergories
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#94D7D7] to-[#987FDD] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}
